import {IRestrictionValue} from "./restriction-value.interface";
import {IRawRestrictionEntityTypeValue} from "../../firebase/topics/messages/raw-data/restrictions-update.raw-data";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {NullableDate} from "../../../../common/types/nullable-types";
import {Lazy} from "../../../../utils/lazy";
import {Check} from "@sparkware/app-utils";
import {RESTRICTION_ACTIONS, RESTRICTION_REASONS} from "./restrictions-constants";
import {RestrictionMessages} from "./restriction-messages";

export class GenericRestrictionValue implements IRestrictionValue {
    constructor(private readonly actionId: number,
                private readonly rawRestrictionValue: IRawRestrictionEntityTypeValue,
                private readonly services: IServiceFactoryExtended) {
    }

    private readonly _expirationDate: Lazy<NullableDate> = new Lazy<NullableDate>(() => {
        if(!Check.isNullOrUndefined(this.rawRestrictionValue.ComputedExpirationDate)) {
            return new Date(this.rawRestrictionValue.ComputedExpirationDate);
        }

        return null;
    });

    private readonly _messages: Lazy<RestrictionMessages> = new Lazy<RestrictionMessages>(() => {
        return new RestrictionMessages(this.rawRestrictionValue.ReasonId, this._expirationDate.value, this.services);
    })

    isExpired(): boolean {
        if(!this._expirationDate.value) {
            return false;
        }

        return this._expirationDate.value.getTime() < this.services.time.now();
    }

    isGameAllowedInTheGrid(): boolean {
        return this.isExpired()
            || this.rawRestrictionValue.ReasonId === RESTRICTION_REASONS.SESSION_LIMIT_REACHED
            || this.rawRestrictionValue.Value?.toLowerCase() === 'all';
    }
    isGameAllowedToPlayReal(): boolean {
        return this.isExpired();
    }

    isActiveRestrictionForOpenApplication(): boolean {
        return !this.isExpired() && this.actionId === RESTRICTION_ACTIONS.OPEN_APPLICATION;
    }


    showUserMessage(): void {
        this._messages.value.showUserMessage();
    }



}